import defaultSettings from '@/settings';
var title = defaultSettings.title || 'huikao-admin';
export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return "".concat(title);
  }
  return "".concat(title);
}